import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";

/**
 * Created by Jonas Wålekvist on 2018-05-30.
 */

export class MaskCreator {


    public static createSymbolAreaMaskGraphics(paddingX:number = 0, paddingY:number = 0, color:number = 0xFFFFFF, alpha:number = 0.5):PIXI.Graphics {
        const gfx = new PIXI.Graphics();
        gfx.beginFill(color, alpha);
        gfx.drawRect(-paddingX, -10,
            GameConfig.instance.REEL_AREA_WIDTH + paddingX * 2,
            GameConfig.instance.REEL_AREA_HEIGHT + 10 + paddingY * 2);
        gfx.endFill();
        return gfx;
    }


    public static createMaskGraphics(width:number, height:number, color:number = 0xFFFFFF, alpha:number = 0.5):PIXI.Graphics {
        let gfx = new PIXI.Graphics();
        gfx.beginFill(color, alpha);
        gfx.drawRect(0, 0,
            width,
            height);
        gfx.endFill();
        return gfx;
    }
}
